/**
 * Milestone/achievement system type definitions
 */

/**
 * Types of milestone rewards
 */
export enum MilestoneRewardType {
  CURRENCY = 'currency',
  INVENTORY_EXPANSION = 'inventory_expansion',
  EXPERIENCE = 'experience',
}

/**
 * A single reward for completing a milestone
 */
export interface MilestoneReward {
  type: MilestoneRewardType;
  value: number;
  description: string;
}

/**
 * Categories of milestones for organization
 */
export enum MilestoneCategory {
  COLLECTION = 'collection',
  ECONOMY = 'economy',
  FISHING = 'fishing',
  BUDDY = 'buddy',
  STREAK = 'streak',
  TRAPPING = 'trapping',
}

/**
 * A milestone definition (static config)
 */
export interface MilestoneDefinition {
  id: string;
  name: string;
  description: string;
  category: MilestoneCategory;
  icon: string;
  rewards: MilestoneReward[];
  /** Function name in the condition registry that checks if milestone is earned */
  conditionKey: string;
}
